import React from 'react';
import { connect } from 'react-redux';
import StatisticsByReferralMetrics from './StatisticsByReferralMetrics.js';
import actions from './StatisticsByReferralMetrics.actions';
import {
    mainSelector,
    getMetrics
} from './StatisticsByReferralMetrics.selectors';
import ReportByReferralComponent from '../../../../utils/ReportByReferralComponent/ReportByReferralComponent';

const reportUtils = ReportByReferralComponent.utils;

const StatisticsByReferralMetricsComponent = connect(
    function mapStateToProps(state, ownProps) {
        const data = mainSelector(state);
        const fallbackMetrics = getMetrics(state);
        const metrics = typeof ownProps.metrics === 'string' && ownProps.metrics.length
            ? ownProps.metrics
            : fallbackMetrics;
        const checkedKeys = reportUtils.getKeysMetric(metrics || reportUtils.getDefStrMetric());

        return {
            data,
            metrics,
            checkedKeys,
            location: state.routing.locationBeforeTransitions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            saveServerStorage: actions.saveServerStorage
        };
    }
)(StatisticsByReferralMetrics);

export default StatisticsByReferralMetricsComponent;
